import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

type ThisApi = ApiDefinition['/questionnaire-templates/{creatorId}/{questionnaireTemplateId}/field-templates']['GET'];
type Input = ThisApi['params'];

const getFieldTemplatesForQuestionnaireTemplate = async ({
  creatorId,
  questionnaireTemplateId,
}: Input): Promise<ThisApi['response']> => {
  const path = `/questionnaire-templates/${creatorId}/${questionnaireTemplateId}/field-templates`;
  const data = await formsBackendClient.get(path);
  return data.data;
};

export default getFieldTemplatesForQuestionnaireTemplate;
